export const selectToken = (state) => state.user.token;

export const selectUser = (state) => state.user;

export const selectUserStudents = (state) => state.user.students;
